export const itemsByCategory = {
  business: {
    defaultValue: 'typical',
    items: [
      'typical', // Типовой ремонт
      'design', // Дизайнерский ремонт
      'finishing', // Под чистовую отделку
      'majorRepairsRequired', // Требуется капитальный ремонт
      'cosmeticRepairsRequired', // Требуется косметический ремонт
    ],
  },
  freeAppointmentObject: {
    defaultValue: 'typical',
    items: [
      'typical', // Типовой ремонт
      'design', // Дизайнерский ремонт
      'finishing', // Под чистовую отделку
      'majorRepairsRequired', // Требуется капитальный ремонт
      'cosmeticRepairsRequired', // Требуется косметический ремонт
    ],
  },
  office: {
    defaultValue: 'office',
    items: [
      'office', // Офисная отделка
      'finishing', // Под чистовую отделку
      'majorRepairsRequired', // Требуется капитальный ремонт
      'cosmeticRepairsRequired', // Требуется косметический ремонт
    ],
  },
  shoppingArea: {
    defaultValue: 'typical',
    items: [
      'typical', // Типовой ремонт
      'design', // Дизайнерский ремонт
      'finishing', // Под чистовую отделку
      'majorRepairsRequired', // Требуется капитальный ремонт
      'cosmeticRepairsRequired', // Требуется косметический ремонт
    ],
  },
  building: {
    defaultValue: 'typical',
    items: [
      'typical', // Типовой ремонт
      'design', // Дизайнерский ремонт
      'finishing', // Под чистовую отделку
      'majorRepairsRequired', // Требуется капитальный ремонт
      'cosmeticRepairsRequired', // Требуется косметический ремонт
    ],
  },
  industry: {
    defaultValue: 'typical',
    items: [
      'typical', // Типовой ремонт
      'majorRepairsRequired', // Требуется капитальный ремонт
      'cosmeticRepairsRequired', // Требуется косметический ремонт
    ],
  },
  warehouse: {
    defaultValue: 'typical',
    items: ['typical', 'majorRepairsRequired', 'cosmeticRepairsRequired'],
  },
};

export default [
  {
    text: 'Требуется косметический ремонт',
    value: 'cosmeticRepairsRequired',
  },
  {
    text: 'Дизайнерский ремонт',
    value: 'design',
  },
  {
    text: 'Под чистовую отделку',
    value: 'finishing',
  },
  {
    text: 'Требуется капитальный ремонт',
    value: 'majorRepairsRequired',
  },
  {
    text: 'Офисная отделка',
    value: 'office',
  },
  {
    text: 'Типовой ремонт',
    value: 'typical',
  },
];
